import { useState, useEffect, useRef } from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/outline';

const RoomChat = ({ roomId, userId, username, messages, onSendMessage }) => {
  const [message, setMessage] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!message.trim()) return;
    
    onSendMessage({
      roomId,
      userId,
      username,
      message: message.trim()
    });
    
    setMessage('');
  };

  return (
    <div className="flex flex-col h-full bg-dark-lighter rounded-lg border border-gray-700">
      <div className="bg-dark-lightest p-3 border-b border-gray-700 rounded-t-lg">
        <h3 className="text-white font-medium">Room Chat</h3>
      </div>
      
      <div className="flex-grow overflow-y-auto p-4 space-y-3" style={{ maxHeight: '400px' }}>
        {messages && messages.length > 0 ? (
          messages.map((msg, index) => (
            <div 
              key={index} 
              className={`flex ${msg.userId === userId ? 'justify-end' : 'justify-start'}`}
            >
              <div 
                className={`max-w-[80%] rounded-lg px-3 py-2 ${
                  msg.userId === userId 
                    ? 'bg-primary text-white rounded-br-none' 
                    : 'bg-dark-lightest text-gray-200 rounded-bl-none'
                }`}
              >
                <div className="flex items-center gap-1 mb-1">
                  <span className={`text-xs font-medium ${
                    msg.userId === userId ? 'text-blue-200' : 'text-blue-400'
                  }`}>
                    {msg.username}
                  </span>
                  <span className="text-xs text-gray-400">
                    {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
                <p className="break-words">{msg.message}</p>
              </div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center h-full">
            <p className="text-gray-400">No messages yet. Start the conversation!</p>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
      
      <form onSubmit={handleSubmit} className="p-3 border-t border-gray-700">
        <div className="flex gap-2">
          <input
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            className="flex-grow bg-dark-lightest border border-gray-700 rounded px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <button
            type="submit"
            disabled={!message.trim()}
            className={`p-2 rounded-full ${
              message.trim() 
                ? 'bg-primary hover:bg-primary/90 text-white' 
                : 'bg-gray-700 text-gray-400 cursor-not-allowed'
            }`}
          >
            <PaperAirplaneIcon className="h-5 w-5" />
          </button>
        </div>
      </form>
    </div>
  );
};

export default RoomChat;
